module.exports = __webpack_public_path__ + "media/images/home-963491251438039f1566dfa818b92a95.png";